import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import '../evidence/evidence.css';
import Sidebar from '../dashboard/Sidebar';
import Dashheader from '../Dash-header/Dashheader';

import CheckedImg from '../../images/checked.svg';
import UncheckImg from '../../images/cross-icon.svg';
import uploadBoxDoc from '../../images/doc-icon.svg';
import AppvImg from '../../images/rounded-check.svg';
import PendImg from '../../images/pending-icon.svg';
import RejImg from '../../images/rejected-icon2.svg';
import { END_URL, IMG_URL } from "../../config.js";
import ImageWithAuthModal from '../../components/Images/ImageWithAuthModal.jsx';
import UploadFileWidget from './UploadFileWidget';

import UserFooter from '../footer/UserFooter.jsx';

function Evidence() {
  const [evidenceList, setEvidenceList] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedEvidenceId, setSelectedEvidenceId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showAllEvidence, setShowAllEvidence] = useState(false);
  const [expanded1, setExpanded] = useState(false);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);

  // Modal states
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');

  const [sortOrder, setSortOrder] = useState("desc");

  const [sortedList, setsortedList] = useState([]);

  const [UserFileTypes,setUserFileTypes] = useState([]);


  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const [imageExtensions, setImageExtensions] = useState([
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'svg',
    'bmp',
    'tiff',
    'ico',
  ]);

  const isImageFile = (filename) => {
    const extension = filename.toLowerCase();
    return imageExtensions.includes(extension);
  };

  const token = sessionStorage.getItem('authToken');

  useEffect(() => {
    fetchEvidence();
  }, []);

  

    useEffect(() => {
      
      if (sortOrder === "asc") {

        const ascList = [...sortedList].sort((a, b) => a - b);
        const sortedEvidence = ascList
          .map((id) => evidenceList.find((e) => e.id === id))
          .filter((e) => e !== undefined);
        setEvidenceList(sortedEvidence);

      } else {
        const descList = [...sortedList].sort((a, b) => b - a);
        const sortedEvidence = descList
          .map((id) => evidenceList.find((e) => e.id === id))
          .filter((e) => e !== undefined);
        setEvidenceList(sortedEvidence);
      }

    }, [sortOrder]);


   const [dynamicContent, setDynamicContent] = useState({
    evidencetitle: '',
    evidenceonelinetitle: '',
    evidencecontent: ''
  });

  useEffect(() => {
    fetchEvidence();
    fetchDynamicContent();
  }, []);

  // Fetch dynamic page content
  const fetchDynamicContent = async () => {
    try {
    const response = await axios.get(`${END_URL}dynamic-page`);

      if (response.data.status && response.data.data) {
        setDynamicContent({
          evidencetitle: response.data.data.evidencetitle,
          evidenceonelinetitle: response.data.data.evidenceonelinetitle,
          evidencecontent: response.data.data.evidencecontent
        });
      }
    } catch (error) {
      console.error("Error fetching dynamic content:", error);
    }
  };




  const fetchEvidence = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(`${END_URL}evidenceindex`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEvidenceList(response.data.evidence);

      setsortedList(response.data.asc_sorted_ids);

      if (response?.data?.evidence && Array.isArray(response.data.evidence)) {
        const file_types = response.data.evidence.map((item) => item.filetype);
        setUserFileTypes(file_types);
      }

    } catch (error) {
      console.error("Error fetching evidence:", error);
    }
  };

  const handleEdit = (id) => {
    setSelectedEvidenceId(id);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleEditSubmit = async (id) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('image', selectedFile);

      await axios.post(`${END_URL}evidenceedit/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      fetchEvidence();

      setSelectedFile(null);
      setSelectedEvidenceId(null);

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error editing evidence:", error);
    }
  };

  const toggleViewMore = () => {
    setShowAllEvidence(!showAllEvidence);
  };

  const handleDelete = (id) => {
    setDeleteConfirmationId(id);
  };

  const confirmDelete = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      await axios.post(
        `${END_URL}evidencedelete/${deleteConfirmationId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      fetchEvidence();
      setShowDeleteModal(true);
      setDeleteConfirmationId(null);
    } catch (error) {
      console.error("Error deleting evidence:", error);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmationId(null);
  };
  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };


  const approvedCount = evidenceList.filter(e => e.status === 'accepted').length;
  const pendingCount = evidenceList.filter(e => e.status === 'pending').length;
  const rejectedCount = evidenceList.filter(e => e.status === 'rejected').length;



  const filteredEvidence = evidenceList.filter(e =>
    (statusFilter ? e.status === statusFilter : true) &&
    (typeFilter ? e.filetype === typeFilter : true)
  );


  return (
    <div className="dashboard-container full-width">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="form-container">
                <div className="dashbord-first">
                  <div dangerouslySetInnerHTML={{ __html: dynamicContent.evidencetitle }}></div>
                  {/* <h4>These may include:</h4>
                    <ul>
                      <li>Proof of purchase (receipts, credit card/bank statements)</li>
                      <li>Loyalty program history (e.g. Flybuys)</li>
                      <li>Screenshots or records of promotional pricing</li>
                      <li>Any relevant correspondence (e.g. emails from Coles)</li>
                    </ul> */}
                </div>
                <div className="content-card">

                <div className="upload-option">
                  <div className="card-section">
                  
                  <h3>{dynamicContent.evidenceonelinetitle}</h3>
              

                  <div className="uploadrow-main">
                    <div className="upload-inst">
                       <div dangerouslySetInnerHTML={{ __html: dynamicContent.evidencecontent }}></div>
                    </div>
                    <div className="upload-itm">
                      <UploadFileWidget />
                    </div>
                  </div>

                  </div>


                  <div className="upload-row1">
                    <div className="upload-col11">
                      <h2>Uploaded Files </h2>
                   
                      <div className="filters-summary-row">
                    <div>
                      <strong>{approvedCount}</strong> Verified
                    </div>
                    <div>
                      <strong>{pendingCount}</strong> Pending Review
                    </div>
                    <div>
                      <strong>{rejectedCount}</strong> Action Required
                    </div>
                    <select className="filters" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} >
                      <option value="">All Statuses</option>
                      <option value="accepted">Verified</option>
                      <option value="pending">Pending</option>
                      <option value="rejected">Rejected</option>
                    </select>
                    
                    <select className="filters"
                      value={typeFilter}
                      onChange={(e) => setTypeFilter(e.target.value)}>

                      <option value="">All Types</option>
      
                      {[...new Set(UserFileTypes)].map((value) => (
                        <option key={value} value={value}>
                          {value
                            .replace(/-/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                        </option>
                      ))}

                    </select>

                  </div>
                   
                      {evidenceList.length > 5 && (
                        <button onClick={toggleViewMore} className="view-more-btn">
                          {showAllEvidence ? 'View Less' : 'View More'}
                        </button>
                      )}
                    </div>

                      {filteredEvidence && filteredEvidence.length > 0 ? (

                        <div className="upload-col2">
                          {/* <h2>Admin Feedback</h2> */}
                          <div className="upload-list">
                            <table>
                              <thead>
                                <tr>
                                  <th>File name</th>
                                  <th>Type</th>
                                    <th
                                        onClick={toggleSortOrder}
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                      >
                                        Date Uploaded{" "}
                                        <span className="sort-icon">
                                          {sortOrder === "asc" ? "▲" : "▼"}
                                        </span>
                                    </th>
                                  <th>Status</th>
                                  <th>Admin Feedback</th>

                                  
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredEvidence.map((evidence) => (
                                  <tr key={evidence.id}>

                                  {isImageFile(evidence.extension) ? (
                                    <td 
                                          onClick={() => openImageModal(evidence.image)}
                                          
                                          style={{ cursor: "pointer" }}
                                    >
                  
                                    <h6>{evidence.image_name}</h6>

                                  </td>
                                  ) : (

                                      <td className="file-type-cell">
                                          
                                            <h6>{evidence.image_name}</h6>

                                      </td>
                                  )}


                                    <td>{evidence.filetype}</td>
                                    <td>{new Date(evidence.created_at).toLocaleDateString()}</td>

                                    <td>
                                      {evidence.status === 'accepted' && <span className='badge success'>Verified</span>}
                                      {evidence.status === 'rejected' && <span className='badge rejected'>Rejected</span>}
                                      {evidence.status === 'pending' && <span className='badge pending'>Pending</span>}
                                    </td>
                                    <td> {evidence.status === 'pending' ? 'Awaiting review...' : evidence.reject_reason }</td>
                                  
                                    <td>
                                      <input
                                        id={`fileInput${evidence.id}`}
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                      />
                                
                                      <button className="delete-btn" onClick={() => handleDelete(evidence.id)}>Remove</button>

                                      {deleteConfirmationId && (
                                        <div className="modal-overlay">
                                          <div className="modal-content">
                                            <h2>Confirm Delete</h2>
                                            <p>Are you sure you want to remove this file? This action cannot be undone.</p>
                                            <div className="modal-buttons">
                                            
                                              <button onClick={cancelDelete} className="cancel-btn">Cancel</button>
                                                <button onClick={confirmDelete} className="confirm-btn">Confirm Delete</button>
                                            </div>
                                          </div>
                                        </div>
                                      )}


                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>


                      ) : 
                      (
                          <p>
                              {statusFilter
                                ? "No matching files found"
                                : "No files uploaded"}
                          </p>
                      )}


                  </div>
                </div>

                </div>                            
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Success</h2>
            <p>Evidence updated successfully!</p>
            <button onClick={() => setShowSuccessModal(false)}>Close</button>
          </div>
        </div>
      )}

      {/* Delete Success Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Success</h2>
            <p>Evidence deleted successfully!</p>
            <button onClick={() => setShowDeleteModal(false)}>Close</button>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {showImageModal && (
        <div className="modal-overlay">
          <div className="modal-content image-modal">
            {/* <img src={selectedImage} alt="Full Size" /> */}

             <ImageWithAuthModal
                imageName={selectedImage}
                apiBaseUrl={END_URL}
                token={token}
                openImageModal={openImageModal}
              />

            <button onClick={closeImageModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Evidence;
